export default __webpack_public_path__ + "static/media/3665.0322b28e.png";